:host{font-size:3.2rem}:host::ng-deep .list>.list-item:not(:last-child){margin-bottom:2rem}
/*# sourceMappingURL=assignment-gap-choice.component-ERJWPPAR.css.map */
